"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationManager = exports.Notification = exports.NotificationPlugin = void 0;
const _ = __importStar(require("lodash"));
const debug_1 = __importDefault(require("debug"));
const core_1 = require("@integro/core");
const portal_vue_1 = require("portal-vue");
const log = (0, debug_1.default)('itp:ui:components:notification:plugin');
const PORTAL_TARGET = 'notification';
const createId = () => `notification-${(0, core_1.uniqueID)()}`;
const PROP = '$notification';
const PROP_PRIV = '$$notification';
exports.NotificationPlugin = {
    install(Vue, options) {
        const manager = new NotificationManager();
        Vue.mixin({
            beforeCreate() {
                _.set(this, PROP_PRIV, new Notification(this, manager));
            }
        });
        if (!Vue.prototype.hasOwnProperty(PROP)) {
            Object.defineProperty(Vue.prototype, PROP, {
                get() {
                    if (!this || !this[PROP_PRIV]) {
                        console.warn(`"${PROP}" must be accessed from a Vue instance "this" context.`);
                    }
                    return this[PROP_PRIV];
                }
            });
        }
    }
};
class Notification {
    owner;
    manager;
    constructor(owner, manager) {
        this.owner = owner;
        this.manager = manager;
    }
    show(options) {
        return this.manager.show(options, this.owner);
    }
    close(id) {
        return this.manager.close(id);
    }
}
exports.Notification = Notification;
const TOAST_MESSAGE_DEFAULTS = {
    message: '',
    title: '',
    toaster: 'b-toaster-bottom-left',
    variant: 'info',
    autoHideDelay: 5000
};
class NotificationManager {
    $$instances;
    constructor() {
        this.$$instances = [];
    }
    get instances() {
        return this.$$instances;
    }
    show(props, owner) {
        log('show %o, owner: %o', props, owner);
        let id = createId();
        log('id: %s', id);
        return new Promise((resolve, reject) => {
            const passengers = [
                owner.$root.$createElement('ItpNotification', {
                    attrs: { id },
                    props: { ...props, uid: id }
                })
            ];
            portal_vue_1.Wormhole.open({
                from: id,
                to: PORTAL_TARGET,
                passengers,
                order: 1
            });
            this.$$instances.push({ id, resolve, reject });
        });
    }
    close(id) {
        log('close %s', id);
        const instance = _.find(this.$$instances, { id });
        if (!instance) {
            console.warn(`Notification instance "${name}" not found.`);
            return;
        }
        portal_vue_1.Wormhole.close({ from: id, to: PORTAL_TARGET });
        _.remove(this.$$instances, instance);
        instance.resolve();
    }
}
exports.NotificationManager = NotificationManager;
//# sourceMappingURL=plugin.js.map